import React from "react";
import { EXPS } from "../utils/expProfileDB";

const clickExpt = (number) => {
  window.location.href += `/${number}`;
};
const Card = (props) => {
  const exptObj = EXPS[props.number];
  return (
    <button
      className="card bg-base-100 shadow-xl"
      onClick={() => clickExpt(props.number + 1)}
    >
      <figure className="flex flex-col justify-center">
        <img src={exptObj.image} height="200" alt="Expt profile" />
      </figure>
      <div className="card-body text text-center">
        <h2 className="card-title text text-center">
          {exptObj.name}
          {/* <div className="badge badge-secondary">NEW</div> */}
        </h2>
        <p>{exptObj.title}</p>
        <div className="card-actions justify-end">
          {/* <div className="badge badge-outline">Fashion</div>
            <div className="badge badge-outline">Products</div> */}
        </div>
      </div>
    </button>
  );
};
export default Card;
